import { createContext, useContext, useState, useEffect } from 'react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const LanguageContext = createContext();

export const SUPPORTED_LANGUAGES = {
  en: { name: 'English', native: 'English', flag: '🇬🇧' },
  fr: { name: 'French', native: 'Français', flag: '🇫🇷' },
  yo: { name: 'Yoruba', native: 'Yorùbá', flag: '🇳🇬' },
  ha: { name: 'Hausa', native: 'Hausa', flag: '🇳🇬' },
  ig: { name: 'Igbo', native: 'Igbo', flag: '🇳🇬' },
};

export function LanguageProvider({ children }) {
  const [language, setLanguage] = useState(() => {
    return localStorage.getItem('cv_language') || 'en';
  });
  const [translations, setTranslations] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchTranslations(language);
  }, [language]);

  const fetchTranslations = async (lang) => {
    try {
      const response = await fetch(`${API}/translations/${lang}`);
      if (response.ok) {
        const data = await response.json();
        setTranslations(data);
      }
    } catch (error) {
      console.error('Error fetching translations:', error);
    } finally {
      setLoading(false);
    }
  };

  const changeLanguage = (newLang) => {
    if (SUPPORTED_LANGUAGES[newLang]) {
      setLanguage(newLang);
      localStorage.setItem('cv_language', newLang);
    }
  };

  const t = (key, fallback) => {
    return translations[key] || fallback || key;
  };

  return (
    <LanguageContext.Provider value={{ 
      language, 
      changeLanguage, 
      t, 
      translations,
      loading,
      supportedLanguages: SUPPORTED_LANGUAGES 
    }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
}

export default LanguageContext;
